module.exports = __webpack_public_path__ + "static/media/logo_blue.3035df6b.svg";